import type { Report } from "../types";

const reportConfig: { [k: string]: Report[] } = {
  local: [
    { reportId: "5683d448-732e-4f28-b399-761c35f2ef94", name: "Availity RLS Test" },
    { reportId: "e6bef167-e0de-469c-a130-ca6d64e034e3", name: "Executive Summary" },
    { reportId: "909c99e0-a7f5-4763-a00f-c79aa1fdabd8", name: "Inpatient Utilization" },
    { reportId: "e1138aae-7049-4fe3-8d8f-0656be9ba33b", name: "Provider Scorecard" },
  ],
  dev: [
    { reportId: "5683d448-732e-4f28-b399-761c35f2ef94", name: "Availity RLS Test" },
    { reportId: "e6bef167-e0de-469c-a130-ca6d64e034e3", name: "Executive Summary" },
    { reportId: "909c99e0-a7f5-4763-a00f-c79aa1fdabd8", name: "Inpatient Utilization" },
    { reportId: "e1138aae-7049-4fe3-8d8f-0656be9ba33b", name: "Provider Scorecard" },
  ],
  stage: [
    { reportId: "5683d448-732e-4f28-b399-761c35f2ef94", name: "Availity RLS Test" },
    { reportId: "e6bef167-e0de-469c-a130-ca6d64e034e3", name: "Executive Summary" },
    { reportId: "909c99e0-a7f5-4763-a00f-c79aa1fdabd8", name: "Inpatient Utilization" },
    { reportId: "e1138aae-7049-4fe3-8d8f-0656be9ba33b", name: "Provider Scorecard" },
  ],
  prod: [{ reportId: "2bdf0e35-7e4d-4dbf-b14c-3b749fe22183", name: "Executive Summary" }],
};

export const environmentReports = reportConfig[import.meta.env.VITE_ENV] || [];
